import { Component, inject, input } from '@angular/core';
import { DialogConfirmationComponent } from '../../../dialog-confirmation/dialog-confirmation.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-info-modal',
    templateUrl: './info-modal.component.html',
    styleUrls: ['./info-modal.component.scss'],
    standalone: false
})
export class InfoModalComponent {
    private dialog = inject(MatDialog);

    readonly textModal = input<string>(undefined);
    readonly titleModal = input<string>(undefined);
    readonly accentColor = input<boolean>(false);
    readonly larger = input<boolean>(false);

    helpClick() {
        this.dialog.open(DialogConfirmationComponent, {
            data: {
                title: this.titleModal(),
                content: this.textModal(),
                isConfirmation: false,
                larger: this.larger()
            }
        });
    }

    getIconBackgroundColor(): string {
        return this.accentColor() ? 'var(--brand-accent)' : '#FFF';
    }
}
